import React from 'react'
import { isNumber } from 'lodash'
import { actions } from '../../../../store/reducers/assignment.reducer'
import { setPendingApprovalPatternId } from '../../../../store/slices/pattern.slice'
import { Button } from 'antd'
import { getColorByIndex } from '../../../../utils/colors.helper'
import { useAssignmentAccess } from '../../components/access/Access'
import { AssignmentPermissions } from '../../../../constants/assignment-permissions'
import { useDispatch, useSelector } from 'react-redux'
import patternSelectors from '../../../../store/selectors/pattern.selectors'
import clusterSelectors from '../../../../store/selectors/cluster.selectors'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import { useParams } from 'react-router'
import submissionSelectors from '../../../../store/selectors/submission.selectors'
import { LANGUAGES } from '../../../../constants/languages'
import { actions as compareSnippetsActions } from '../../../../store/reducers/compare-snippets.reducer'
import CompareFilesModal from '../../../../components/common/compare-snippets/CompareFilesModal'
import { submissionActions } from '../../../../store/slices/submission.slice'

const ActionsSection = () => {
    const language = useSelector(assignmentSelectors.language)
    const clusters = useSelector(clusterSelectors.all)
    const pendingApprovalPatternId = useSelector(patternSelectors.pendingApprovalPatternId)
    const selectedSubmissionIds = useSelector(submissionSelectors.selectedSubmissionIds)
    const allSubmissionsDetailed = useSelector(submissionSelectors.allSubmissionsDetailed)
    const queryComparisonMode = useSelector(assignmentSelectors.queryComparisonMode)
    const showCompareSnippetsModal = useSelector(state => state.compareSnippets.showModal)
    const isWaitingForSelectSubgroup = useSelector(state => state.assignment.isWaitingForSelectSubgroup)
    const dispatch = useDispatch()

    const { token, layerId } = useParams()

    const hasEditingPermission = useAssignmentAccess([AssignmentPermissions.CAN_EDIT])

    const dumbSubmission = submissionId => {
        const submission = clusters
            .map(cluster => cluster.files)
            .flat()
            .find(file => file.id === submissionId)
        return {
            name: submission.name,
            content: allSubmissionsDetailed[submission.id]?.content,
            patternsList: submission.motifList?.map(motif => ({
                motifId: motif?.motif_id,
                startRow: motif?.start_row,
                endRow: motif?.end_row,
                color: getColorByIndex(motif?.color_id).value,
            })),
            language,
        }
    }

    const handleUnselectAll = () => dispatch(submissionActions.resetSelectedSubmissionIds())

    let saveAssignmentButton = null
    let revertButton = null
    let exitQueryComparisonButton = null
    let exitSelectionButton = null
    let selectSubgroupWithSamePatternsButton = null
    let compareFiles = null
    let moveSelectedFilesToAnotherGroup = null

    if (isNumber(pendingApprovalPatternId)) {
        const handleRevert = async () => {
            const response = await dispatch(actions.deletePattern(token, layerId, pendingApprovalPatternId))
            if (response) dispatch(setPendingApprovalPatternId(null))
        }

        const handleSaveAssignmentClick = async () => {
            dispatch(actions.setEditingPattern({ id: pendingApprovalPatternId }))
            dispatch(setPendingApprovalPatternId(null))
        }

        saveAssignmentButton = (
            <Button type='primary' onClick={handleSaveAssignmentClick}>
                Save assignment
            </Button>
        )
        revertButton = (
            <Button onClick={handleRevert} danger>
                Revert
            </Button>
        )
    } else if (queryComparisonMode) {
        const handleExitComparisonMode = () => {
            dispatch(actions.fetchClusters(token, layerId))
        }

        exitQueryComparisonButton = (
            <Button danger onClick={handleExitComparisonMode}>
                Exit query comparison mode
            </Button>
        )
    } else if (selectedSubmissionIds.length === 1 && language !== LANGUAGES.EXCEL.value) {
        const handleSelectSubgroupWithSamePatterns = () => {
            dispatch(actions.selectSubgroupWithSamePatterns(token, layerId))
        }

        selectSubgroupWithSamePatternsButton = (
            <Button onClick={handleSelectSubgroupWithSamePatterns} loading={isWaitingForSelectSubgroup}>
                Select subgroup with same patterns
            </Button>
        )
    } else if (selectedSubmissionIds.length === 2) {
        const handleCompareSnippets = () => {
            dispatch(compareSnippetsActions.setShowModal(true))
            dispatch(compareSnippetsActions.setFirstSnippet(dumbSubmission(selectedSubmissionIds[0])))
            dispatch(compareSnippetsActions.setSecondSnippet(dumbSubmission(selectedSubmissionIds[1])))
        }

        compareFiles = <Button onClick={handleCompareSnippets}>Compare files</Button>
    }
    if (selectedSubmissionIds.length) {
        exitSelectionButton = (
            <Button onClick={handleUnselectAll} danger>
                Exit selection mode
            </Button>
        )
        moveSelectedFilesToAnotherGroup = (
            <Button
                onClick={() => dispatch(actions.setShowMoveSelectedFilesToAnotherGroupModal(true))}
                disabled={!hasEditingPermission}
            >
                Move to another group
            </Button>
        )
    }

    return (
        <div className='action-buttons-container'>
            {showCompareSnippetsModal && (
                <CompareFilesModal
                    showModal={showCompareSnippetsModal}
                    handleClose={() => dispatch(compareSnippetsActions.setShowModal(false))}
                />
            )}
            {saveAssignmentButton}
            {revertButton}
            {exitSelectionButton}
            {exitQueryComparisonButton}
            {moveSelectedFilesToAnotherGroup}
            {selectSubgroupWithSamePatternsButton}
            {compareFiles}
        </div>
    )
}

export default ActionsSection
